<template>
  <div class="plus-minus">
    <div class="plus-minus-icon plus-minus-plus" @click="$emit('plus')"/>
    <div class="plus-minus-icon plus-minus-minus" @click="$emit('minus')"/>
  </div>
</template>

<script>
export default {
  props: {

  },
  data () {
    return {

    }
  },
  computed: {

  },
  methods: {
    
  }  
}
</script>

<style lang="scss">
  .plus-minus {
    height: 25px;
    width: 12px;
    margin-right: 4px;
    position: relative;
    top: -4px;
    left: -4px;
    
  }

  .plus-minus-icon {
    cursor: pointer;
    height: 12px;
    width: 12px;
    border-radius: 50%;
    border: 1px dashed #ccc;
    background-size: contain;
    margin: 0 0 3px;
  }
  .plus-minus-plus {
    background-image: url(https://i.imgur.com/ypgXjiR.png);
  }
  .plus-minus-minus {
    background-image: url(https://i.imgur.com/8GWdLtm.png);
  }
</style>
